var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".note_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5.5a2 2 0 0 1 2 2v15.025a5.975 5.975 0 0 1-5.975 5.975H2.5a2 2 0 0 1-2-2v-19a2 2 0 0 1 2-2Z",
    className: "note_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.42V19.5a1 1 0 0 1 1-1h3.92M3.5 6.5h17M3.5 10.5h17M3.5 14.5h17M3.5 18.5h11M6.5 3.5v17",
    className: "note_svg__a"
  })));
};
export default SvgNote;